import { render } from "./DeductionList.vue?vue&type=template&id=2304e13f&scoped=true"
import script from "./DeductionList.vue?vue&type=script&lang=js"
export * from "./DeductionList.vue?vue&type=script&lang=js"

import "./DeductionList.vue?vue&type=style&index=0&id=2304e13f&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2304e13f"],['__file',"src/views/h5/crm/kpi/DeductionList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2304e13f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2304e13f', __exports__)) {
    api.reload('2304e13f', __exports__)
  }
  
  module.hot.accept("./DeductionList.vue?vue&type=template&id=2304e13f&scoped=true", () => {
    api.rerender('2304e13f', render)
  })

}


export default __exports__